const TYPE = {

  HTTP_METHOD : {
    GET : 'get',
    POST : 'post',
    PUT : 'put',
    DELETE : 'delete'
  },

  DEVICE : {
    PC : 'v-pc',
    PAD : 'v-tab',
    PHONE : 'v-mob'
  },

  ORIENTATION : {
    PORTRAIT : 'portrait',
    LANDSCAPE : 'landscape'
  },

  CHANNEL : {
    GM_APP: 'BRS1000',
    WJTB: 'WJTB',
    GM: 'BRS1000',
    GLOBAL01: 'GLOBAL01',
  },

  ENTRY_TYPE: {
    WJTB: 'WJTB',
    GM: 'GM',
    GM_APP: 'GM_APP',
    MATH_PID: '',
    GLOBAL01: 'GLOBAL01',
    CP: 'CP'
  },

  LEARNING : {
    COURSE : 'LESC01',
    TOPIC : 'LESC02'
  },

  LEARNING_ENTRY : {
    AIBRS : 'AIBRS',
    SBJTMATH : 'SBJTMATH',
    OCR : 'OCR',
    THMA : 'THMA'
  },

  SEARCH : {
    STAGE_NAME : 'STGNM',
    STAGE_CODE : 'STGCD',
    QUESTION_CODE : 'QSTCD'
  },

  ID : {
    ANSWER_AREA : 'answerArea'
  },

  ANSWER : {
    ORDER : 'CTS01',
    NO_ORDER : 'CTS02',
    EITHER : 'CTS03'
  },

  ANSWERING_QUESTIONS_PROGRESS : {
    CONTINUE : 'W',
    DRILL_DOWN : 'D',
    CONCEPT_CHECK : 'C',
    COMPLETE : 'E',
    TOPIC_LEARNING_RECOMMENDATION_AND_COMPLETE : 'T',
    FALSENESS_COMPLETE : 'B',
    USER_CLOSE : 'U',
    SYSTEM_CLOSE : 'X'
  },

  ANSWERING_QUESTIONS_SPEED : {
    SLOW : 'ESC01',
    NORMAL : 'ESC02',
    FAST : 'ESC03'
  },

  LATEX_CODE : {
    INTERVAL_TABLE : 'interval-table',
    NUMBER_TABLE : 'number-table',
    COLLECT_AND_SPLIT : 'collect-and-split',
    MULTIPLICATION_AND_DIVISION : 'multiplication-and-division',
    FACTORS_AND_MULTIPLES : 'factors-and-multiples',
    SIZE_COMPARISON : 'size-comparison',
    PRIME_FACTORIZATION : 'prime-factorization',
    CYCLIC_DECIMAL : 'cyclic-decimal',
    FACTORIZATION : 'factorization',
    DISTRIBUTIVE_LAW : 'distributive-law'
  },

  MATHJAX : {
    DEFAULT : 'TYPE.MATHJAX.DEFAULT',
    ANSWERING_QUESTIONS : 'TYPE.MATHJAX.ANSWERING_QUESTIONS',
    CHECK_WRONG_ANSWER : 'TYPE.MATHJAX.CHECK_WRONG_ANSWER'
  },

  INPUT : {
    KEYBOARD : 'INP_KBD',
    KEYPAD : 'INP_KPD',
    NOTES : 'INP_PEN',
    NONE : 'NONE'
  },

  KEY_STROKE : {
    LEFT : 'Left',
    RIGHT : 'Right',
    BACKSPACE : 'Backspace'
  },

  KEYPAD : {
    NUMBER : 'KP01',
    CALCULATION : 'KP02',
    COMPLEX_CALCULATION : 'KP03',
    NOTE : 'notepad',
    MULTIPLE: 'multiple',
  },

  KEYPAD_MORE : {
    SIZE_COMPARISON : 'more-size-comparison',
    PARENTHESIS : 'more-parenthesis',
    EQUAL_SIGN : 'more-equal-sign',
    VARIABLE : 'more-variable',
    CALCULATE_SIGN : 'more-calculate-sign',
    COMMA : 'more-comma',
    A : 'more-a',
    B : 'more-b',
    C : 'more-c',
    D : 'more-d',
    E : 'more-e',
    F : 'more-f',
    G : 'more-g',
    H : 'more-h'
  },

  RECOGNIZE_RANGE : {
    ELEMENTARY : {
      TYPE1 : 'Elementary-Type1',
      TYPE2 : 'Elementary-Type2',
      TYPE3 : 'Elementary-Type3'
    },
    MIDDLE : {
      TYPE1 : 'Middle-Type1'
    }
  },

  LOGIN : {
    DUPLICATE : 'DUP',
    EXPIRES : 'EXP',
  },

  EXPL_ACRCY_CD: {
    D: 'D', // 미달
    C: 'C', // 보통
    B: 'B', // 높음  
    A: 'A', // 완벽
  },

  //학습진행 상태코드 - LPSC01: 노력, LPSC02: 기본, LPSC03: 충분, LPSC04: 훌륭
  LRN_PRGS_STS_CD: {
    LPSC01: 'LPSC01',  //노력
    LPSC02: 'LPSC02',  //기본
    LPSC03: 'LPSC03',  //충분
    LPSC04: 'LPSC04',  //훌륭
  },

  LOG : {
    VERB : {
      ATTEMPTED : 'attempted',
      OPENED : 'opened',
      MARKED : 'marked',
      DELETED : 'deleted',
      ANSWERED : 'answered',
      COMPLETED : 'completed',
      TERMINATED : 'terminated',
      INITIALIZED : 'initialized',
      PLAYED : 'played',
      PAUSED : 'paused',
      SEEKED : 'seeked',
      ACCESSED : 'accessed'
    },
    OBJECT : {
      ASSESSMENT : 'assessment',
      QUESTION : 'question',
      VIDEO : 'video',
      EXPLANATION : 'explanation',
      LEARNING_REPORT : 'learningReport',
      SCREEN : 'screen'
    }
  },

  GB_USER_TYPE: {
    GUEST: 'GUEST',
    MEMBER: 'MEMBER'
  },

  COUNTRY_CODE : {
    KOREA : 'KR',
    INDIA : 'IN',
    PHILIPPINES : 'PH'
  },

  PAYMENT : {
    KR : {
      COUNTRY_CODE : 'KR',
      CURRENCY_CODE : 'KRW',
      PRODUCT_ID : 'subscription_1month',
      PRODUCT_CODE : 15000,
    },
    IN : {
      COUNTRY_CODE : 'IN',
      CURRENCY_CODE : 'INR',
      PRODUCT : {
        DAY : {
          TITLE : 'Dailly Plan',
          ID : 'premium_1day_ovs',
          CODE : 0.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80% ',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '₹ 399.99',
            NOW : '₹ 77.99'
          },
          SUBSCRIBE : false 
        },
        LIFE_TIME : {
          TITLE : 'Lifetime Plan',
          ID : 'premium_lifetime_ovs',
          CODE : 4.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '₹ 1,969.99',
            NOW : '₹ 389.99'
          },
          SUBSCRIBE : false 
        },
      }
      // PRODUCT_ID : 'mathpid_subscription_year',
      // PRODUCT_CODE : 3.99,
    },
    PH : {
      COUNTRY_CODE : 'PH',
      CURRENCY_CODE : 'PHP',
      PRODUCT : {
        DAY : {
          TITLE : 'Dailly Plan',
          ID : 'premium_1day_ovs',
          CODE : 0.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '₱ 269.99',
            NOW : '₱ 53.99'
          },
          SUBSCRIBE : false 
        },
        MONTH : {
          TITLE : 'Monthly Plan',
          ID : 'subscription_1month_ovs',
          CODE : 1.99,
          BADGE : {
            BEST : true,
            DISCOUNT_RATE : '87%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '₱ 799.99',
            NOW : '₱ 99.99'
          },
          SUBSCRIBE : true 
        },
        YEAR : {
          TITLE : 'Yearly Plan',
          ID : 'mathpid_subscription_year',
          CODE : 3.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '₱ 1,099.99',
            NOW : '₱ 209.99'
          },
          SUBSCRIBE : true 
        },
        LIFE_TIME : {
          TITLE : 'Lifetime Plan',
          ID : 'premium_lifetime_ovs',
          CODE : 4.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '₱ 1,399.99',
            NOW : '₱ 269.99'
          },
          SUBSCRIBE : false 
        },
      // PRODUCT_ID : 'mathpid_subscription_year',
      // PRODUCT_CODE : 3.99, // ₱209.99
      }
    },
    US : {
      COUNTRY_CODE : 'US',
      CURRENCY_CODE : 'USD',
      PRODUCT : {
        DAY : {
          TITLE : 'Dailly Plan',
          ID : 'premium_1day_ovs',
          CODE : 0.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '$ 4.99',
            NOW : '$ 0.99'
          },
          SUBSCRIBE : false 
        },
        MONTH : {
          TITLE : 'Monthly Plan',
          ID : 'subscription_1month_ovs',
          CODE : 1.99,
          BADGE : {
            BEST : true,
            DISCOUNT_RATE : '87%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '$ 14.99',
            NOW : '$ 1.99'
          },
          SUBSCRIBE : true 
        },
        YEAR : {
          TITLE : 'Yearly Plan',
          ID : 'mathpid_subscription_year',
          CODE : 3.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '$ 19.99',
            NOW : '$ 3.99'
          },
          SUBSCRIBE : true 
        },
        LIFE_TIME : {
          TITLE : 'Lifetime Plan',
          ID : 'premium_lifetime_ovs',
          CODE : 4.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '$ 24.99',
            NOW : '$ 4.99'
          },
          SUBSCRIBE : false 
        },
      }
    },
    GB : {
      COUNTRY_CODE : 'GB',
      CURRENCY_CODE : 'EUR',
      PRODUCT : {
        DAY : {
          TITLE : 'Dailly Plan',
          ID : 'premium_1day_ovs',
          CODE : 0.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '£ 4.19',
            NOW : '£ 0.79'
          },
          SUBSCRIBE : false 
        },
        MONTH : {
          TITLE : 'Monthly Plan',
          ID : 'subscription_1month_ovs',
          CODE : 1.99,
          BADGE : {
            BEST : true,
            DISCOUNT_RATE : '87%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '£ 12.59',
            NOW : '£ 1.59'
          },
          SUBSCRIBE : true 
        },
        YEAR : {
          TITLE : 'Yearly Plan',
          ID : 'mathpid_subscription_year',
          CODE : 3.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '£ 16.79',
            NOW : '£ 3.29'
          },
          SUBSCRIBE : true 
        },
        LIFE_TIME : {
          TITLE : 'Lifetime Plan',
          ID : 'premium_lifetime_ovs',
          CODE : 4.99,
          BADGE : {
            BEST : false,
            DISCOUNT_RATE : '80%',
            TEXT : 'OFF'
          }, 
          PRICE : {
            PREV : '£ 20.99',
            NOW : '£ 4.19'
          },
          SUBSCRIBE : false 
        },
      }
    }
  },

  TUTORIAL : {
    STEP1 : 'step1',
    STEP2 : 'step2',
    STEP3 : 'step3',
  } 
};

export default TYPE;
